import { convertToNumber } from '@/utils/common';
import { formatDate, DATE_FORMAT } from '@/utils/date';

const COMMON_NULL_MESSAGE = 'Không có';

export class ProductBatchStock {
  constructor(data) {
    this.batchCode = data.batchCode
      ? data.batchCode.trim()
      : COMMON_NULL_MESSAGE;
    this.storeName = data.storeName
      ? data.storeName.trim()
      : COMMON_NULL_MESSAGE;
    this.productName = data.productName
      ? data.productName.trim()
      : COMMON_NULL_MESSAGE;
    this.quantity = data.quantity
      ? new ProductBatchQuantity(data.quantity)
      : new ProductBatchQuantity({});
    this.importDate = data.importDate
      ? formatDate(data.importDate, DATE_FORMAT)
      : COMMON_NULL_MESSAGE;
    this.createdAt = data.createdAt
      ? formatDate(data.createdAt, DATE_FORMAT)
      : COMMON_NULL_MESSAGE;
    this.updatedAt = data.updatedAt
      ? formatDate(data.updatedAt, 'HH:mm DD/MM/YYYY')
      : COMMON_NULL_MESSAGE;
    this.createdByName = data.createdByName
      ? data.createdByName.trim()
      : '';
    this.id = data.id;
    this.productId = data.productId;
    this.barCode = data.barCode;
  }
}

class ProductBatchQuantity {
  constructor(data) {
    this.inStockQuantity = convertToNumber({
      value: data.inStockQuantity,
      defaultValue: 0,
    });
    this.transferQuantity = convertToNumber({
      value: data.transferQuantity,
      defaultValue: 0,
    });
    this.warrantyQuantity = convertToNumber({
      value: data.warrantyQuantity,
      defaultValue: 0,
    });
    this.holdingQuantity = convertToNumber({
      value: data.holdingQuantity,
      defaultValue: 0,
    });
  }
}
